// @flow @jsx h

import { Component, h } from 'preact'

import styles from './index.css'

type Person = {
  navn: string,
  epost: string
}

type Group = {
  gruppenavn: string,
  personer: Person[]
}

type FooterType = {
  credits: Group[],
  published: string,
  facebookUrl: string,
  twitterUrl: string
}

type Props = {
  footer: FooterType
}

export class Footer extends Component<Props> {
  render () {
    const { footer } = this.props
    const { credits, published, facebookUrl, twitterUrl } = footer
    return <div class={styles.footer}>

      {
        credits.map((group, idx) => {
          return <div key={idx} class={styles.footer__group}>
            <h4>{group.gruppenavn}</h4>
            <ul>
              {group.personer.map((person, idx) => {
                if (person.epost) {
                  return <li><a key={idx} href={'mailto:' + person.epost}>{person.navn}</a></li>
                } else {
                  return <li>{person.navn}</li>
                }
              })}
            </ul>
          </div>
        })
      }

      <div class={styles.footer__published}>{published}</div>
      <div class={styles.footer__navigation}>
        <div class={styles.footer__nrklogo}>
          <svg width='3.5em' height='1.4em' aria-hidden='true'>
            <use xlinkHref='#nrk-logo-nrk' />
          </svg>
          <span class='nrk-sr'>Gå til nrk.no</span>
        </div>

        <ul class={styles.footer__shareButtons}>
          <li>
            <a data-share='Article:Facebook' rel='noopener noreferrer' target='_blank' href={facebookUrl}>
              <span className='nrk-sr'>Del på Facebook</span>

              <svg width='30' height='30' aria-hidden='true'>
                <use xlinkHref='#nrk-some-facebook' />
              </svg>
            </a>
          </li>
          <li>
            <a data-share='Article:Twitter' rel='noopener noreferrer' target='_blank' href={twitterUrl}>
              <span class='nrk-sr'>Del på Twitter</span>
              <svg width='30' height='30' aria-hidden='true'>
                <use xlinkHref='#nrk-some-twitter' />
              </svg>
            </a>
          </li>
        </ul>
      </div>
    </div>
  }
}
